export function createProviderRegistry(domain) {
  const providers = new Map()

  return {
    domain,
    register(provider) {
      if (!provider?.id) {
        throw new Error(`[${domain}] provider.id is required`)
      }

      providers.set(provider.id, provider)
      return provider
    },
    get(providerId) {
      return providers.get(providerId) || null
    },
    has(providerId) {
      return providers.has(providerId)
    },
    list() {
      return Array.from(providers.values())
    },
  }
}
